import React from 'react';
import { Box, Placeholder } from '@stitch-fix/mode-react';
import { RECOMMENDATIONS_PER_PAGE } from '../../PaginatedRecommendations/PaginatedRecommendations';
import RecommendationsGrid from '../RecommendationsGrid';
const LoadingRecommendations = () => <RecommendationsGrid gridItems={Array.from({
  length: RECOMMENDATIONS_PER_PAGE
}, (_, index) => <Box data-testid="loading-placeholder" key={`placeholder-${index}`}>
        <Placeholder variant="rect" width="100%" height={0} pt="125%" />
        <Placeholder width={4} mt={1} />
        <Placeholder width={8} mt={0.25} />
        <Placeholder width={2} mt={0.25} />
      </Box>)} />;
export default LoadingRecommendations;